import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { 
  HomeIcon, 
  SettingsIcon, 
  ListIcon, 
  LogOutIcon,
  UserIcon,
  ShieldIcon 
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <HomeIcon className="w-5 h-5" /> },
    { name: "Enquiry Alerts", path: "/enquiryalerts", icon: <SettingsIcon className="w-5 h-5" /> },
    { name: "Logs & Analytics", path: "/logs", icon: <ListIcon className="w-5 h-5" /> },
    { name: "User Profile", path: "/account", icon: <UserIcon className="w-5 h-5" /> },
    { name: "Admin Page", path: "/admin", icon: <ShieldIcon className="w-5 h-5" /> },
  ];

  const handleLogout = () => {
    // Clear session or user data
    logout(); // If using AuthContext to clear user session
    localStorage.removeItem("user"); // If using localStorage for session management

    // Redirect to login page
    navigate("/");
  };


  return (
    <div className="w-64 h-screen bg-gradient-to-b from-blue-900 to-indigo-950 text-white fixed left-0 top-0 shadow-xl">
      <div className="p-6 border-b border-blue-800 flex items-center justify-between">
        <h1 className="text-2xl font-bold tracking-wider">SPL</h1>
        <div className="bg-blue-700 rounded-full p-2">
          <UserIcon className="w-5 h-5" />
        </div>
      </div>
      
      <nav className="mt-8">
        <ul className="space-y-2 px-4">
          {menuItems.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className={`
                  flex items-center 
                  p-3 
                  rounded-lg 
                  group 
                  transition-all 
                  duration-300 
                  ${
                    location.pathname === item.path
                      ? "bg-blue-700 text-white"
                      : "text-blue-200 hover:bg-blue-800 hover:text-white"
                  }
                `}
              >
                <span className={`
                  mr-4 
                  ${location.pathname === item.path 
                    ? "text-white" 
                    : "text-blue-400 group-hover:text-white"
                  }
                `}>
                  {item.icon}
                </span>
                <span className="font-medium">{item.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-blue-800">
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center p-3 rounded-lg text-blue-200 hover:bg-blue-800 hover:text-white transition-all duration-300"
        >
          <LogOutIcon className="w-5 h-5 mr-3" />
          Logout
        </button>
      </div>
    </div>
  );
}

export default Sidebar;